import React from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { cookies } from '@/data/content';
import Button from './Button';

const CookieConsentBanner: React.FC = () => {
    const { consented, accept, dismiss } = useCookieConsent();

    if (consented !== null) {
        return null;
    }

    return (
        <div
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:w-[480px] z-50 animate-in slide-in-from-bottom-5 fade-in duration-300"
            role="dialog"
            aria-live="polite"
            aria-label={cookies.aria_label}
        >
            <div className="bg-app-surface border border-app-border rounded-2xl p-5 shadow-2xl flex flex-col gap-3">
                <p className="font-bold text-app-text m-0 text-base">{cookies.title}</p>
                <p className="text-sm text-app-muted m-0 leading-relaxed">
                    {cookies.description}{' '}
                    <a href="/politique-confidentialite" className="text-app-primary hover:underline font-medium">
                        {cookies.policy_label}
                    </a>
                    .
                </p>
                {/* Both buttons have equal visual weight — CNIL requirement */}
                <div className="flex gap-3 mt-1">
                    <Button variant="secondary" size="sm" fullWidth onClick={dismiss}>
                        {cookies.reject_label}
                    </Button>
                    <Button variant="primary" size="sm" fullWidth onClick={accept}>
                        {cookies.accept_label}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentBanner;
